<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/subscription/" + subscription.id + "/change-status"'>
        <template #title>Subscription change status</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Current status {{ subscription.statusCustomerFriendlyName() }}</p>

            <Select class='mt-4' name='status'
                v-model:value='value.reason'
                label='Status' 
                placeholder='New status'
                :options="[
                    { value: 1, html: 'New' },
                    { value: 2, html: 'Build' },
                    { value: 3, html: 'Build failed' },
                    { value: 4, html: 'Build complete' },
                    { value: 5, html: 'Send' },
                    { value: 6, html: 'Send failed' },
                    { value: 7, html: 'Send complete' },
                    { value: 30, html: 'Live' },
                    { value: 70, html: 'Paused' },
                    { value: 80, html: 'Past due' },
                    { value: 81, html: 'Auto remove' },
                    { value: 99, html: 'Cancelled' },
                    { value: 100, html: 'Removed' }
                ]" 
            />

            <Textarea name='reason' v-model:value='value.reason_other' 
                label='Other reason'
                class='mt-4'
            /> 

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Update subscription
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                value: {
                    trial_end: null,
                    reason: null,
                    reason_other: '',
                }
            }
        },

        created() {
            this.value.trial_end = this.currentTrial.format('DD/MM/YYYY')
        },

        computed: {
            subscription() {
                return this.editingModel
            },

            currentTrial() {
                if (this.editingModel.stripe_trial_ends_at != null) {
                    return this.$moment(this.editingModel.stripe_trial_ends_at)
                }

                return this.$moment()
            },

            min() {
                return this.currentTrial.diff(this.$moment(), 'days')+1;
            },
        }
    }
</script>